export var getStyles = function getStyles(props) {
  var className = props.className,
    iconClassName = props.iconClassName,
    isPlaceholder = props.isPlaceholder,
    isImage = props.isImage,
    styles = props.styles;
  return {
    root: [isImage && 'ms-Icon-imageContainer', isPlaceholder && 'ms-Icon-placeHolder', {
      display: 'inline-block'
    }, isPlaceholder && {
      width: '1em'
    }, isImage && {
      overflow: 'hidden'
    }, iconClassName, className, styles && styles.root, styles && styles.imageContainer]
  };
};